import { createFileRoute } from '@tanstack/react-router'
import { ReportPage, reportSearches } from '@/features/analytics/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'

const persistence = reportSearches.salesperson
export const Route = createFileRoute('/_authenticated/reports/salespeople')({
  validateSearch: persistence.validateSearch,
  beforeLoad: (options) => persistence.restore(options),
  component: Page,
  head: () => ({ meta: [{ title: '业务员分析 · Super Mega' }] })
})
function Page() {
  const { currentSession } = Route.useRouteContext()
  const { search, navigateSearch } = usePersistedListQuery({
    persistence,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate: Route.useNavigate()
  })
  return <ReportPage dimension="salesperson" search={search} navigate={navigateSearch} />
}
